import {useMutation} from 'react-query';
import {useLocation, useNavigate} from 'react-router-dom';
import {chooseWinner} from 'services/myAd/winner';
interface IUseChooseWinnerProps {
  cardType: 'auction' | 'prepayment';
  action?: () => void;
}
const useChooseWinner = ({cardType, action}: IUseChooseWinnerProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isFarm = location.pathname.includes('farm');
  const {mutate} = useMutation({
    mutationFn: (payload: IChooseWinner) => {
      return chooseWinner(payload, cardType);
    },
    onSuccess: () => {
      navigate(`/${isFarm ? 'farm' : 'wholesaler'}/my-advertisment`);
      action && action();
    },
  });
  return {mutate};
};

export default useChooseWinner;
